import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { profileService, UpdateProfileData } from '@/services/profileService';
import type { ApiError } from '@/services/api';

export function useProfile() {
  return useQuery({
    queryKey: ['profile'],
    queryFn: () => profileService.getProfile(),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}

export function useUpdateProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateProfileData) => profileService.updateProfile(data),
    onSuccess: (response) => {
      // Update profile cache
      queryClient.setQueryData(['profile'], (old: any) => ({
        ...old,
        user: response.user,
      }));
    },
    onError: (error: ApiError) => {
      console.error('Profile update failed:', error.message);
    },
  });
}

export default {
  useProfile,
  useUpdateProfile,
};
